import { Webview } from '@/proto/WebviewProto'
import { Activity } from '@/proto/ActivityProto'
import * as SafeBuffer from 'safe-buffer'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import crypto from 'crypto'
import axios from 'axios'
import { Nation } from '@/types'
import { Timer } from './questionnaireTimer'
import { showFailToast } from 'vant'
import { t } from '@/lang'

const DEFAULT_API = isDev() ? 'https://gw.sin-test.link/' : ''
export function md5(data: any) {
  const md5 = crypto.createHash('md5')
  return md5.update(data).digest('hex')
}

export function encode(protobufData: any): SafeBuffer.Buffer {
  const aes_key = SafeBuffer.Buffer.from('SEWkGIc2RiqcASstuR4kuw==', 'base64')
  const ci = crypto.createCipheriv('aes-128-ecb', aes_key, '')
  const crypted = ci.update(SafeBuffer.Buffer.from(protobufData))
  return SafeBuffer.Buffer.concat([
    SafeBuffer.Buffer.from(crypted),
    SafeBuffer.Buffer.from(ci.final()),
  ])
}

export function decode(protobufData: any): any {
  const aes_key = SafeBuffer.Buffer.from('SEWkGIc2RiqcASstuR4kuw==', 'base64')
  const deci = crypto.createDecipheriv('aes-128-ecb', aes_key, '')
  const decrypted = deci.update(SafeBuffer.Buffer.from(protobufData))
  return SafeBuffer.Buffer.concat([
    SafeBuffer.Buffer.from(decrypted),
    SafeBuffer.Buffer.from(deci.final()),
  ])
}

export function getP(protoData: any, ts: number) {
  const sign_key = SafeBuffer.Buffer.from('ZTY5NDMxZDNkMDY5NGU0Mjg2ODVmZQ==', 'base64')
  const input = SafeBuffer.Buffer.concat([
    SafeBuffer.Buffer.from(protoData),
    SafeBuffer.Buffer.from(ts.toString()),
    sign_key,
  ])
  return md5(input)
}

export function getFullUrl(params: Record<string, any>, path: string) {
  const { url = DEFAULT_API } = getUrlParams()
  const _url = url + path + '?'
  Object.keys(params).reduce((pre, cur) => {
    return `${pre}${cur}=${params[cur]}&`
  }, url)
  return _url.toString()
}

export function getUrlParams(): {
  token: string
  brd: string
  brand_code?: string
  user_id: string
  userid?: string
  aid: string
  code: string
  lan: string
  svn: string
  svc: string // number
  cvc: string //  number
  cvn: string
  chn: string
  pkg: string
  app?: number
  url: string
  nst?: string
  eid?: string
} {
  // 使用es5的方式获取url参数
  const url = window.location.href
  const params: any = {}
  // eslint-disable-next-line prettier/prettier
  const str = url.split('?').slice(1).join('&')
  if (str) {
    const strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      params[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1])
    }
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return {
    ...params,
  }
}

export function getHeader(ts: number) {
  const {
    token = '',
    userid = '',
    aid = '',
    code = '',
    svn = '',
    svc = '',
    cvc = '',
    cvn = '',
    chn = '',
    pkg = '',
    brand_code = '',
    eid = '',
    app = '',
    lan = '',
  } = getUrlParams()
  if (isDev()) {
    return {
      timestamp: ts,
      token: '2fa249fda5fc491d9abcf337b4444b66',
      user_id: 12593095,
      aid: '9be34768bce29bf206e5b23ac58e4f29',
      brd: 'int',
      code: 'vn',
      lan: 'en',
      svn: 'h',
      svc: '1',
      cvc: '1',
      cvn: '3.1.5',
      chn: 'website',
      pkg: 'com.int.h5',
      app: 0,
      eid: '',
    }
  }
  return {
    timestamp: ts,
    token,
    user_id: Number(userid),
    aid,
    brd: brand_code,
    code,
    lan,
    svn,
    svc,
    cvc,
    cvn,
    chn,
    pkg,
    app,
    eid,
  }
}

export function getParams(ts: number): Record<string, any> {
  const {
    token = '',
    userid = '',
    aid = '',
    code = '',
    svn = '',
    svc = '',
    cvc = '',
    cvn = '',
    chn = '',
    pkg = '',
    brand_code = '',
    eid = '',
    app = '',
    lan = '',
    url = '',
  } = getUrlParams()
  if (isDev()) {
    return {
      timestamp: ts,
      token: '2fa249fda5fc491d9abcf337b4444b66',
      user_id: 751253,
      aid: '9be34768bce29bf206e5b23ac58e4f29',
      brd: 'int',
      code: 'vn',
      lan: 'en',
      svn: 'h',
      svc: '1',
      cvc: '1',
      cvn: '3.1.5',
      chn: 'website',
      pkg: 'com.int.h5',
      app: 0,
      eid: '',
    }
  }
  return {
    timestamp: ts,
    token,
    user_id: Number(userid),
    aid,
    brd: brand_code,
    code,
    lan,
    svn,
    svc,
    cvc,
    cvn,
    chn,
    pkg,
    app,
    eid,
    url,
  }
}

// 获取问卷详情
export async function fetchSurvey(survey_conf_id: number, fn: any) {
  console.log('Fetching survey', survey_conf_id)
  const path = '/api/v1/proxy/10026/2/'
  const { ActDetailReq } = Webview
  const { ProxyReq, ReqHeader, ProxyResp } = Activity

  const ts = Date.now()
  const header = getHeader(ts)
  if (!header.user_id) return

  const Body = ActDetailReq.fromObject({
    timestamp: ts,
  })
  const params = getParams(ts)

  const request = ProxyReq.fromObject({
    header: ReqHeader.fromObject(params),
    data: Body.serializeBinary(),
  })

  const { url = DEFAULT_API } = getUrlParams()
  // params.sign = getP(request.serializeBinary(), ts)
  // params.eid = md5(getFullUrl(params, path)) // 经测试，eid随便是什么都可以，但游戏中是这么设置的，那就这么设置吧
  console.log('params', params)
  const response = await axios.post(`${url}${path}`, encode(request.serializeBinary()), {
    headers: {
      'Content-Type': 'application/x-protobuf',
    },
    responseType: 'arraybuffer',
    params,
  })
  console.log('fetchresponsesss', response)
  if (response) {
    const buffer = decode(response.data)
    const result = ProxyResp.deserializeBinary(buffer).toObject()
    console.log('result', result)
    fn(result?.data, result?.header?.msg)
  }
}

// 提交问卷
export async function submitSurvey(survey_conf_id: number, question_content: string, fn: any) {
  const path = '/api/v1/proxy/10026/3/'
  const { SubmitSurveyReq } = Webview
  const { ProxyReq, ReqHeader, ProxyResp } = Activity
  const ts = Date.now()

  const Body = SubmitSurveyReq.fromObject({
    timestamp: ts,
    conf_id: survey_conf_id.toString(),
    take_time: Timer.getTime(),
    question_content,
  })
  const params = getParams(ts)

  const request = ProxyReq.fromObject({
    header: ReqHeader.fromObject(params),
    data: Body.serializeBinary(),
  })
  const { url = DEFAULT_API } = getUrlParams()
  // params.sign = getP(request.serializeBinary(), ts)

  // params.eid = md5(getFullUrl(params, path)) // 经测试，eid随便是什么都可以，但游戏中是这么设置的，那就这么设置吧

  const response = await axios.post(`${url}${path}`, encode(request.serializeBinary()), {
    headers: {
      'Content-Type': 'application/x-protobuf',
    },
    responseType: 'arraybuffer',
    params,
  })
  console.log('Submitrespons', response)
  if (response.data) {
    const buffer = decode(response.data)
    const result = ProxyResp.deserializeBinary(buffer).toObject()
    if (result.header?.code === 404) {
      // 404 表示问卷活动已失效
      showFailToast({
        message: t().A26(),
        duration: 3000,
      })
      return
    }
    fn(result.data, result?.header?.msg)
  }
}

export const close = () => {
  window.close()
  // 预览时使用
  window.parent.postMessage(
    {
      type: 'survey-close',
    },
    '*'
  )
}

export const getCode = (): Nation => {
  const { code } = getUrlParams()
  return code as Nation
}

export function isDev() {
  return process.env.NODE_ENV === 'development'
}

export function randomArray(arr: any[]) {
  return arr.sort(() => Math.random() - 0.5)
}

export function getOptionsExceptOther(options: any) {
  // 提取 other 选项，将其放在最后，并且剩余选项乱序
  const other = options.find((item: any) => item.isOther)
  const rest = options.filter((item: any) => !item.isOther)
  const randomRest = randomArray(rest)
  if (other) {
    return [...randomRest, other]
  }
  return randomRest
}

export function isNaN(num: any) {
  return Object.prototype.toString.call(num) === '[object Number]' && num !== num
}

// 预览答题结果测试数据
export const dataRes = {
  created_at: '2025-10-23 08:14:20',
  updated_at: '2025-10-23 08:14:20',
  title: 'test02',
  questions: [
    {
      question_id: 1761186856900,
      question_type: 'single_select',
      title: '单选题',
      content: {
        title: '单选题',
        description: 'danxuanti01',
        question_id: 1761186856900,
        is_necessary: true,
        is_random: false,
        is_jump: false,
        question_type: 'single_select',
        options: [
          {
            content: '',
            position_id: 1761186856901,
            score: 0,
            contentJson: { label: '11', value: 1761186856901, image: '', isOther: false },
          },
          {
            content: '',
            position_id: 1761186890200,
            score: 0,
            contentJson: { label: '22', value: 1761186890200, image: '', isOther: false },
          },
          {
            content: '',
            position_id: 1761186901193,
            score: 0,
            contentJson: { label: '33', value: 1761186901193, image: '', isOther: false },
          },
          {
            content: '',
            position_id: 1761186902671,
            score: 0,
            contentJson: { label: '44', value: 1761186902671, image: '', isOther: false },
          },
        ],
        group: [],
        disabled: true,
        showNecessary: true,
        showRandom: true,
        showJump: true,
        showAction: true,
      },
      is_random: false,
      is_necessary: true,
      jump: {},
      options: [
        {
          position_id: 1761186856901,
          content: '{"label":"11","value":1761186856901,"image":"","isOther":false}',
          score: 0,
        },
        {
          position_id: 1761186890200,
          content: '{"label":"22","value":1761186890200,"image":"","isOther":false}',
          score: 0,
        },
        {
          position_id: 1761186901193,
          content: '{"label":"33","value":1761186901193,"image":"","isOther":false}',
          score: 0,
        },
        {
          position_id: 1761186902671,
          content: '{"label":"44","value":1761186902671,"image":"","isOther":false}',
          score: 0,
        },
      ],
      position_ids: [1761186890200],
      answer: '',
    },
    {
      question_id: 1761186905648,
      question_type: 'multi_select',
      title: '多选题',
      content: {
        title: '多选题',
        description: 'duoxuanti01',
        question_id: 1761186905648,
        is_necessary: true,
        is_random: false,
        is_jump: false,
        question_type: 'multi_select',
        options: [
          {
            content: '',
            position_id: 1761186905649,
            score: 0,
            contentJson: { label: 'test011', value: 1761186905649, image: '', isOther: false },
          },
          {
            content: '',
            position_id: 1761186905650,
            score: 0,
            contentJson: { label: 'test022', value: 1761186905650, image: '', isOther: false },
          },
          {
            content: '',
            position_id: 1761186947909,
            score: 0,
            contentJson: { label: 'test033', value: 1761186947909, image: '', isOther: false },
          },
          {
            content: '',
            position_id: 1761186949885,
            score: 0,
            contentJson: { label: 'test044', value: 1761186949885, image: '', isOther: false },
          },
        ],
        group: [],
        disabled: true,
        showNecessary: true,
        showRandom: true,
        showJump: true,
        showLimitSelect: true,
        showAction: true,
        min: 1,
        max: 2,
      },
      is_random: false,
      is_necessary: true,
      jump: {},
      options: [
        {
          position_id: 1761186905649,
          content: '{"label":"test011","value":1761186905649,"image":"","isOther":false}',
          score: 0,
        },
        {
          position_id: 1761186905650,
          content: '{"label":"test022","value":1761186905650,"image":"","isOther":false}',
          score: 0,
        },
        {
          position_id: 1761186947909,
          content: '{"label":"test033","value":1761186947909,"image":"","isOther":false}',
          score: 0,
        },
        {
          position_id: 1761186949885,
          content: '{"label":"test044","value":1761186949885,"image":"","isOther":false}',
          score: 0,
        },
      ],
      position_ids: [1761186947909],
      answer: '',
    },
    {
      question_id: 1761186962552,
      question_type: 'blank',
      title: '填空题',
      content: {
        title: '填空题',
        description: 'tiankognti01',
        question_id: 1761186962552,
        is_necessary: true,
        is_random: false,
        is_jump: false,
        question_type: 'blank',
        options: [],
        group: [],
        disabled: true,
        showNecessary: true,
        showLimitText: true,
        showAction: true,
        placeholder: '请输入',
      },
      is_random: false,
      is_necessary: true,
      jump: {},
      options: [],
      position_ids: [],
      answer: '99',
    },
    {
      question_id: 1761186992304,
      question_type: 'person',
      title: '信息采集题',
      content: {
        title: '信息采集题',
        description: 'xinxicaijiti01',
        question_id: 1761186992304,
        is_necessary: true,
        is_random: false,
        is_jump: false,
        question_type: 'person',
        options: [],
        group: [],
        disabled: true,
        showAction: true,
        information: [
          { key: 'gender', required: false, options: ['男', '女'] },
          { key: 'age', required: false, options: ['18-60', '60+', '0-17'] },
          {
            key: 'degree',
            required: false,
            options: ['xiaoxue', 'chuzhong', 'gaozhong', 'daxue'],
          },
          { key: 'city', required: false, options: ['wuhan', 'shenz', 'shanghai'] },
        ],
      },
      is_random: false,
      is_necessary: true,
      jump: {},
      options: [],
      position_ids: [],
      answer: '{"gender":"男","age":"18-60","degree":"xiaoxue","city":"wuhan"}',
    },
    {
      question_id: 1761187006858,
      question_type: 'image_select',
      title: '图片选择题',
      content: {
        title: '图片选择题',
        description: 'tupianxuanzeti01',
        question_id: 1761187006858,
        is_necessary: true,
        is_random: false,
        is_jump: false,
        question_type: 'image_select',
        options: [
          {
            content: '',
            position_id: 1761187006859,
            score: 0,
            contentJson: {
              label: '228.jpg',
              value: 1761187006859,
              image:
                'https://img.sin-test.link/survey_2025_10_23_811_6fc64a92afb911f0bd17cae26cbff912',
              isOther: false,
            },
          },
          {
            content: '',
            position_id: 1761187121735,
            score: 0,
            contentJson: {
              label: 'image_720.png',
              value: 1761187121735,
              image:
                'https://img.sin-test.link/survey_2025_10_23_811_74a1852cafb911f09a2acae26cbff912',
              isOther: false,
            },
          },
        ],
        group: [],
        disabled: true,
        showNecessary: true,
        showRandom: true,
        showJump: true,
        showLimitSelect: true,
        showAction: true,
        min: 1,
        max: 2,
      },
      is_random: false,
      is_necessary: true,
      jump: {},
      options: [
        {
          position_id: 1761187006859,
          content:
            '{"label":"228.jpg","value":1761187006859,"image":"https://img.sin-test.link/survey_2025_10_23_811_6fc64a92afb911f0bd17cae26cbff912","isOther":false}',
          score: 0,
        },
        {
          position_id: 1761187121735,
          content:
            '{"label":"image_720.png","value":1761187121735,"image":"https://img.sin-test.link/survey_2025_10_23_811_74a1852cafb911f09a2acae26cbff912","isOther":false}',
          score: 0,
        },
      ],
      position_ids: [1761187121735],
      answer: '',
    },
    {
      question_id: 1761187047352,
      question_type: 'trend',
      title: '趋势题',
      content: {
        title: '趋势题',
        description: 'qushitu01',
        question_id: 1761187047352,
        is_necessary: true,
        is_random: false,
        is_jump: false,
        question_type: 'trend',
        options: [
          {
            content: '',
            position_id: 1761187047353,
            score: 1,
            contentJson: { label: '', value: 1761187047353, image: '', isOther: false },
          },
          {
            content: '',
            position_id: 1761187047354,
            score: 2,
            contentJson: { label: '', value: 1761187047354, image: '', isOther: false },
          },
          {
            content: '',
            position_id: 1761187047355,
            score: 3,
            contentJson: { label: '', value: 1761187047355, image: '', isOther: false },
          },
          {
            content: '',
            position_id: 1761187047356,
            score: 4,
            contentJson: { label: '', value: 1761187047356, image: '', isOther: false },
          },
          {
            content: '',
            position_id: 1761187047357,
            score: 5,
            contentJson: { label: '', value: 1761187047357, image: '', isOther: false },
          },
          {
            content: '',
            position_id: 1761187047358,
            score: 6,
            contentJson: { label: '', value: 1761187047358, image: '', isOther: false },
          },
          {
            content: '',
            position_id: 1761187047359,
            score: 7,
            contentJson: { label: '', value: 1761187047359, image: '', isOther: false },
          },
          {
            content: '',
            position_id: 1761187047360,
            score: 8,
            contentJson: { label: '', value: 1761187047360, image: '', isOther: false },
          },
          {
            content: '',
            position_id: 1761187047361,
            score: 9,
            contentJson: { label: '', value: 1761187047361, image: '', isOther: false },
          },
        ],
        group: [],
        disabled: true,
        showNecessary: true,
        showJump: true,
        showAction: true,
        top: 'zuigao',
        bottom: 'zuidi',
      },
      is_random: false,
      is_necessary: true,
      jump: {},
      options: [
        {
          position_id: 1761187047353,
          content: '{"label":"","value":1761187047353,"image":"","isOther":false}',
          score: 1,
        },
        {
          position_id: 1761187047354,
          content: '{"label":"","value":1761187047354,"image":"","isOther":false}',
          score: 2,
        },
        {
          position_id: 1761187047355,
          content: '{"label":"","value":1761187047355,"image":"","isOther":false}',
          score: 3,
        },
        {
          position_id: 1761187047356,
          content: '{"label":"","value":1761187047356,"image":"","isOther":false}',
          score: 4,
        },
        {
          position_id: 1761187047357,
          content: '{"label":"","value":1761187047357,"image":"","isOther":false}',
          score: 5,
        },
        {
          position_id: 1761187047358,
          content: '{"label":"","value":1761187047358,"image":"","isOther":false}',
          score: 6,
        },
        {
          position_id: 1761187047359,
          content: '{"label":"","value":1761187047359,"image":"","isOther":false}',
          score: 7,
        },
        {
          position_id: 1761187047360,
          content: '{"label":"","value":1761187047360,"image":"","isOther":false}',
          score: 8,
        },
        {
          position_id: 1761187047361,
          content: '{"label":"","value":1761187047361,"image":"","isOther":false}',
          score: 9,
        },
      ],
      position_ids: [1761187047354],
      answer: '',
    },
    {
      question_id: 1761187072761,
      question_type: 'star',
      title: '评星题',
      content: {
        title: '评星题',
        description: 'pingxingti01',
        question_id: 1761187072761,
        is_necessary: true,
        is_random: false,
        is_jump: false,
        question_type: 'star',
        options: [
          {
            content: '',
            position_id: 1761187072762,
            score: 1,
            contentJson: { label: '', value: 1761187072762, image: '', isOther: false },
          },
          {
            content: '',
            position_id: 1761187072763,
            score: 2,
            contentJson: { label: '', value: 1761187072763, image: '', isOther: false },
          },
          {
            content: '',
            position_id: 1761187072764,
            score: 3,
            contentJson: { label: '', value: 1761187072764, image: '', isOther: false },
          },
          {
            content: '',
            position_id: 1761187072765,
            score: 4,
            contentJson: { label: '', value: 1761187072765, image: '', isOther: false },
          },
          {
            content: '',
            position_id: 1761187072766,
            score: 5,
            contentJson: { label: '', value: 1761187072766, image: '', isOther: false },
          },
        ],
        group: [],
        disabled: false,
        showNecessary: true,
        showJump: true,
        showAction: true,
        one: '',
        two: '',
        three: '',
        four: '',
        five: '',
      },
      is_random: false,
      is_necessary: true,
      jump: {},
      options: [
        {
          position_id: 1761187072762,
          content: '{"label":"","value":1761187072762,"image":"","isOther":false}',
          score: 1,
        },
        {
          position_id: 1761187072763,
          content: '{"label":"","value":1761187072763,"image":"","isOther":false}',
          score: 2,
        },
        {
          position_id: 1761187072764,
          content: '{"label":"","value":1761187072764,"image":"","isOther":false}',
          score: 3,
        },
        {
          position_id: 1761187072765,
          content: '{"label":"","value":1761187072765,"image":"","isOther":false}',
          score: 4,
        },
        {
          position_id: 1761187072766,
          content: '{"label":"","value":1761187072766,"image":"","isOther":false}',
          score: 5,
        },
      ],
      position_ids: [1761187072765],
      answer: '',
    },
  ],
  status: 2,
  deleted: true,
  operator: 'summer',
  id: '68f99684559a780e74fcf347',
}
